import { $t } from '@/locales';

export const appUuid: string = '1f351359-1ed9-412b-8eec-62704b3cbb4e';
export const tenantUuid: string = '12f41d80-e738-44d1-b406-072338f0fd41';
export const channel: string = 'Web';
export const ossUrl: string = 'https://gvs-image.oss-cn-shenzhen.aliyuncs.com/';

export const jsonUrlList: Array<string> = ['/developer-platform/api/user/login'];

// 文件上传 超时时间20分钟
export const fileUrlList: Array<string> = [
  '/developer-platform/api/firmware/add',
  '/developer-platform/api/firmware/update',
  '/developer-platform/api/firmware/download' // 固件文件上传、下载、更新
];

// 大数据接口 超时时间60s
export const bigDataUrlList: Array<string> = [
  '/developer-platform/api/user/login', // 登录

  // 跨数据中心
  'developer-platform/api/product/statistics/deviceRegionalDistribution',
  'developer-platform/api/product/statistics/topPopularProduct',
  'developer-platform/api/product/statistics/topProductDeviceNum',
  'developer-platform/api/product/statistics/topPopularProductFunction',
  'developer-platform/api/product/statistics/countDevice',
  'developer-platform/api/product/statistics/countDeviceMsg',
  'developer-platform/api/product/statistics/countProduct',
  'developer-platform/api/application/statistics/countApplication',
  '/developer-platform/api/i18n/dp/product/import',
  '/developer-platform/api/application/template/dp/import'
];

// 错误码处理
interface Params {
  [key: number]: string;
}
// 接口业务错误码
export const backendBusinessErrorCodeObj: Params = {
  // 服务器错误码
  500: 'backendErrorCode.500',
  403: 'backendErrorCode.403',
  3001: 'backendErrorCode.401',
  401: 'backendErrorCode.401',
  '-4008': 'backendErrorCode.401',
  '-2011': 'backendErrorCode.2011',
  '-2010': 'backendErrorCode.2011',
  '-4006': 'backendErrorCode.503',

  // 格式错误的验证码
  1001: 'backendErrorCode.res1',
  1007: 'backendErrorCode.res2',
  1008: 'backendErrorCode.res3',
  1009: 'backendErrorCode.res4',
  1010: 'backendErrorCode.res5',
  1011: 'backendErrorCode.res6',
  1012: 'backendErrorCode.res7',
  1013: 'backendErrorCode.res29',
  2002: 'backendErrorCode.res8',
  2006: 'backendErrorCode.usedMail',
  // 格式错误的验证码

  // 验证码
  1001002006: 'backendErrorCode.1001002006',
  1001002012: 'backendErrorCode.accountNotFound',
  1001002017: 'backendErrorCode.checkCodeError',
  1001002034: 'backendErrorCode.codeFast',
  1001002035: 'backendErrorCode.checkCodeError',
  1001002036: 'backendErrorCode.checkCodeError',

  // 账号相关
  1009001001: 'backendErrorCode.accountNotFound',
  1009001002: 'backendErrorCode.password',
  1009001003: 'backendErrorCode.res11',
  1009001004: 'backendErrorCode.res12',
  1009001005: 'backendErrorCode.res13',
  1009001006: 'backendErrorCode.res14',
  1009001007: 'backendErrorCode.res15',
  1009001008: 'backendErrorCode.res16',
  1009001009: 'backendErrorCode.res17',
  1009001010: 'backendErrorCode.usedMail',
  1009001011: 'backendErrorCode.res18',
  1009001012: 'backendErrorCode.res19',

  1009001013: 'backendErrorCode.1009001013',

  // 角色模块
  1009002001: 'backendErrorCode.roleNameSame',
  1009002003: 'backendErrorCode.roleUsed',
  1009002002: 'backendErrorCode.res20',
  1009002004: 'backendErrorCode.res21',

  // 菜单模块
  1009003001: 'backendErrorCode.res22',
  1009003002: 'backendErrorCode.res23',
  1009003003: 'backendErrorCode.res24',
  1009003004: 'backendErrorCode.res25',

  // 标准品模块
  1009004001: 'backendErrorCode.categorySame',
  1009004002: 'backendErrorCode.groupSame',
  1009004003: 'backendErrorCode.codeSame',
  1009004004: 'backendErrorCode.funcNameSame',
  1009004006: 'backendErrorCode.1009004006',
  1009004007: 'backendErrorCode.1009004007',

  // 租户/客户/企业
  1009005001: 'backendErrorCode.res26',
  1009005002: 'backendErrorCode.res27',
  1009005003: 'backendErrorCode.res28',
  1009005004: 'backendErrorCode.res9',
  1009005005: 'backendErrorCode.res10',
  1009005006: 'backendErrorCode.res4',
  1009005007: 'backendErrorCode.res5',
  1009005008: 'backendErrorCode.res6',
  1009005009: 'backendErrorCode.res31',
  1009005010: 'backendErrorCode.res29',

  1009005012: 'backendErrorCode.1009005012',

  1009005013: '租户空间不存在',
  1009005014: '租户空间不可用',
  1009001014: '用户访问未授权',

  // 设备日志;
  1009006001: 'backendErrorCode.1002000003',

  // ota任务
  1009007001: 'backendErrorCode.1009007001',
  1009007002: 'backendErrorCode.1009007002',
  1003007002: 'backendErrorCode.1003007002',

  // 产品
  1003009003: 'backendErrorCode.1003009003',
  1003009001: 'backendErrorCode.1003009001',
  1003009002: 'backendErrorCode.1003009002',
  1003009004: 'backendErrorCode.1003009004',
  1003009005: 'backendErrorCode.1003009005',
  1009009001: 'backendErrorCode.1009009001',
  1009009002: 'backendErrorCode.1009009002',
  1009010003: 'backendErrorCode.1009010003',

  // 产品固件
  1003010001: 'backendErrorCode.1003010001',
  1003010002: 'backendErrorCode.1003010002',
  1003010003: 'backendErrorCode.1003010003',
  1003011001: 'backendErrorCode.1003011001',
  1003004001: 'backendErrorCode.codeSame',

  // 设备Mock
  1002000003: 'backendErrorCode.1002000003',
  1009005011: 'backendErrorCode.1009005011',
  1009010004: 'backendErrorCode.1009010004',
  1009009003: 'backendErrorCode.1009009003',
  1003007004: 'backendErrorCode.1003007004',
  '-1000000400': 'backendErrorCode.-1000000400',
  // 应用模块
  '1009011003': 'backendErrorCode.1009011003',
  '1009011005': 'backendErrorCode.1009011005',
  '1009011009': 'backendErrorCode.1009011009',
  '1009011008': 'backendErrorCode.1009011008',
  '1009011007': 'backendErrorCode.1009011007',
  '1009011006': 'backendErrorCode.1009011006',
  '1009011004': 'backendErrorCode.1009011004',
  '1009011002': 'backendErrorCode.1009011002',
  '1009011001': 'backendErrorCode.1009011001',
  '1009011011': 'backendErrorCode.1009011011',
  '1009011012': 'backendErrorCode.1009011012',
  '1009011013': 'backendErrorCode.1009011013',
  '1009013001': 'backendErrorCode.1009013001',
  '1009013002': 'backendErrorCode.1009013002',
  '1009013003': 'backendErrorCode.1009013003',
  '1009013004': 'backendErrorCode.1009013004',
  '1002000001': 'backendErrorCode.1002000001',
  '1003012001': 'backendErrorCode.1003012001',
  '1003012002': 'backendErrorCode.1003012002',
  '1003012003': 'backendErrorCode.1003012003',
  '1009011010': 'backendErrorCode.1009011010',
  '1009011014': 'backendErrorCode.1009011014',
  '1009011018': 'backendErrorCode.1009011018'
};
// 接口报错码
export const backendErrorCodeObj: Params = {
  500: 'backendErrorCode.500',
  401: 'backendErrorCode.401',
  503: 'backendErrorCode.503',
  400: 'backendErrorCode.500',
  403: 'backendErrorCode.403'
};
